import { ArticleContainer } from '@3d-scene/model3d/article-container';

export class WireBridgeArticlePostParseProcessor {
  public static process(container: ArticleContainer): void {
    if (container.articleObject3DDataShared) {
      throw new Error('Modifying a shared article geometry is not allowed!');
    }
  }
}
